export default __webpack_public_path__ + "static/media/queue_add.ca59ece1.svg";